<template>
  <div class="wl-container">
    <div class="wl-content-container">

      <!-- 搜索框 -->
      <div class="wl-search-bar">
        <div class="wl-left">
          <el-input :placeholder="$t('MASTER_DATA_PLACE_HOLDER')"
                    v-model="searchContent"
                    maxlength="100"
                    @keyup.enter.native="searchMaster"
                    class="input-with-select"
                    clearable>
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchMaster" style="cursor: pointer" />
          </el-input>
        </div>

        <div class="wl-right">

          <el-button class="wl-green"
                     icon="el-icon-plus"
                     @click="toggleAddVisible">{{$t('COMMON_ADD')}} </el-button>

        </div>
      </div>

      <!-- 表格 -->

      <div class="table-container-wrapper">
        <el-table height="100%"
                  v-loading="loading"
                  :data="data"
                  border
                  stripe>

          <el-table-column type="index"
                           width="70"></el-table-column>

          <el-table-column prop="itemSubject"
                           :label="$t('MASTER_DATA_TABLE_HEADER_ITEM_SUBJECT')"
                           width="180"></el-table-column>

          <el-table-column prop="valueListDisplay"
                           show-overflow-tooltip
                           :label="$t('MASTER_DATA_TABLE_HEADER_VALUE')"></el-table-column>

          <el-table-column prop="action"
                           width="120"
                           align="center"
                           :label="$t('TABLE_HEADER_Action')">
            <template slot-scope="scope">

              <i class="el-icon-edit-outline wl-icon-edit"
                 aria-hidden="true"
                 @click="onEditAccount(scope.row)"></i>

              <i class="el-icon-delete wl-icon-delete"
                 @click="onDeleteAccount(scope.row)"></i>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination class="wl-pagination"
                     :current-page="pagination.pageNum"
                     :page-size="pagination.pageSize"
                     @current-change="onCurrentPageChange"
                     @size-change="onSizeChange"
                     :page-sizes="[10, 50, 100]"
                     layout="prev, pager, next,sizes, total"
                     :total="pagination.total"></el-pagination>

      <!-- 新增的弹框 -->
      <site-add v-if="addVisible"
                :onCancel="toggleAddVisible"
                :data="currentRow"
                :mode="mode"
                :saveLoading="btnLoading"
                :onAddOrEdit="addOrEditMaster" />

    </div>
  </div>
</template>
<script>
import SelectAd from '@/components/common/selectAd'
import API from '@/api'
import { deleteConfirm, loading, UserInput } from '@/utils'
import SiteAdd from './master-add'
import {mapGetters} from 'vuex'

export default {
    name: 'user',
    data() {
        return {
            data: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            btnLoading: false,
            searchContent: '',
            addVisible: false,
            deleteVisible: false,
            mode: '',
            currentRow: {}
        }
    },
    mounted() {
        this.getStaffList()
    },
    computed: {
      ...mapGetters('common', {
        getSite: 'getSite',
      })
    },
    methods: {
        onDeleteAccount(row) {
            this.currentRow = row
            deleteConfirm().then(() => this.deleteUser(row))
        },
        onEditAccount(row) {
            this.toggleAddVisible()
            this.currentRow = row
            this.mode = 'edit'
        },
        searchMaster: _.debounce(
            function() {
                if (this.searchContent && !UserInput.reg.test(this.searchContent)) {
                    this.$message.error(this.$t('ILLEGAL_USER_INPUT_01'))
                    return
                }
                this.onCurrentPageChange(1)
            },
            500,
            { leading: true }
        ),
        onSizeChange(size) {
          this.pagination.pageSize = size
          this.pagination.pageNum = 1
          this.getStaffList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getStaffList()
        },
        toggleAddVisible() {
            this.addVisible = !this.addVisible
            this.currentRow = {}
            this.mode = ''
        },
        getStaffList: async function() {
            try {
                this.loading = true
                const { code, data, errDetails } = await API.system.queryMasterList({
                    ...this.pagination,
                    searchContent: this.searchContent
                })
                if (code == '1') {
                    const toData = v => {
                        return {
                            ...v,
                            valueListDisplay: _.map(v.valueList, v => `[ ${v.itemName}:${v.itemValue} ]`).join(' ; ')
                        }
                    }
                    this.data = _.map(data.records, toData)
                    this.pagination.total = data.total
                    this.loading = false
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {
                this.loading = false
            }
        },
        deleteUser: async function(row) {
            try {
                const { code, data, errDetails } = await API.system.deleteMaster({
                    itemSubject: row.itemSubject,
                    siteId: this.getSite.siteId
                })
                if (code == '1') {
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {}
        },
        addOrEditMaster: async function(form) {
            let service = loading()
            this.btnLoading=!this.btnLoading
            try {
                const api = this.mode === 'edit' ? API.system.editMaster : API.system.addMaster
                service.load()
                const { code, data, errDetails } = await api({
                    siteId: this.getSite.siteId,
                    ...form
                })
                if (code == '1') {
                    this.toggleAddVisible()
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {
                service.close()
                this.btnLoading=!this.btnLoading
            }
        }
    },
    components: {
        SelectAd,
        SiteAdd
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}
.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
  border-radius: 8px;
}
.wl-search-bar {
    height: 45PX;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.wl-left,
.wl-right {
    display: flex;
    justify-content: flex-start;
    justify-items: center;
}
</style>
